<template>
  <li :class="$attrs.class" class="flex justify-between items-center">
    <div class="flex items-center">
      <Link
        v-if="abilities.delete"
        :href="route('cart.discounts.destroy', [id])"
        preserve-scroll
        method="delete"
        class="-m-2 p-2 text-gray-700 hover:text-gray-900"
        as="button"
      >
        <Icon type="cancel" size="5" />
      </Link>
      <span class="ml-2">{{ name }}</span>
      <Code
        class="ml-2"
        :color="theme"
        :value="code"
      />
    </div>
    <strong class="text-blue-500">
      {{ formatPrice(-applied) }}
    </strong>
  </li>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import Code from 'Web/Shared/Code.vue';
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import formatPrice from '@/helpers/formatPrice';
import rescue from '@/helpers/rescue';
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  code: {
    type: [Number, String],
    required: true,
  },
  info: {
    type: String,
    required: false,
  },
  applied: {
    type: [Number, String],
    required: true,
  },
  abilities: {
    type: Object,
    required: true,
  },
  theme: {
    type: String,
    default: 'default',
  },
});

const info = computed(() => rescue(() => JSON.parse(props.info), {
  text: info,
}));

</script>

